import DataProvider from '../data_provider/DataProvider';
import { FindPasswordParams } from '../data_provider/gateways/MailingGateway';
import { UserInfoNotLogInReqParam } from '../data_provider/gateways/UserGateway';
import { Validator } from './Validator';

export type CookieType = {
    KMTK?: string, // 사용자 토큰
    KMUI?: string, // 사용자 아이디
    KMNM?: string, // 사용자 닉네임
    KMPF?: string, // 사용자 로그인 플랫폼
    KMLN?: string, // 로그인 여부
    KMAL?: string, // 자동 로그인 여부
    KMSD?: string, // 이메일 저장 여부
    KMSI?: string, // 저장한 이메일
}

export type isValidCookiesType = {
    userToken?:     boolean,
    email?:         boolean,
    name?:          boolean,
    platform?:      boolean,
    isLogin?:       boolean,
    isAutoLogin?:   boolean,
    isSavedEmail?:  boolean,
    savedEmail?:    boolean,
}

/**
 * @author sukim91
 * @date 2022-10-06 14:37
 * @remark AccountValidator
 * @extends Validator
 * @props None
 */
export class AccountValidator extends Validator {
    constructor() {
        super();
    }

    // 25.03.24 | Kim Young Jun | 비밀번호 찾기 버튼 클릭 시, 메일링 로직
    public async findPasswordByEmail(address: string, host: string): Promise<string> {
        try {

            let params = null;

            params = {
                address: address,
                host: host,
            } as UserInfoNotLogInReqParam

            // 계정 유무 확인
            const userInfoRes = await DataProvider.GetUserNotLogInInfo(params);

            if (!userInfoRes.flag) {
                return "존재하지 않는 아이디입니다.";
            }

            console.log(userInfoRes);

            params = {
                address: address,
                host: host,
            } as FindPasswordParams
        
            // 메일 발송요청
            const mailResponse = await DataProvider.SendFindPassword(params);
            
            if (mailResponse.flag) {
                return `입력한 이메일\n${address}@${host}\n에서 메일을 확인해주세요.`;
            } else {
                return "메일 발송에 실패했습니다. 다시 시도해주세요.";
            }
      
        } catch (error) {
          return error instanceof Error ? error.message : "알 수 없는 오류가 발생했습니다.";
        }
    }

    /** @returns boolean */
    public isValidCookies() {
        const email = this.getCookieWithoutEncoding("KMUI");
        const name = this.getCookieWithEncoding("KMNM");

        this.valid = (!(!email && !name));

        return this.isValid;
    }

    /** @returns string */
    public getCookieWithEncoding(cName : string) {
        let result = null;
        let value = document.cookie.match('(^|;) ?' + cName + '=([^;]*)(;|$)');

        // value가 유효하지 않을 경우
        if (!value)
        {
            return result;
        }

        // value가 유효할 경우
        else
        {
            result = decodeURIComponent(escape(atob(value[2])));

            return result;
        }
    }

    /** @returns string */
    public getCookieWithoutEncoding(cName : string) {
        let result = null;
        let value = document.cookie.match('(^|;) ?' + cName + '=([^;]*)(;|$)');
    
        // value가 유효하지 않을 경우
        if (!value)
        {
            return result;
        }
    
        // value가 유효할 경우
        else
        {
            result = value[2];
    
            return result;
        }
    }

    /** void */
    public setCookieWithEncoding(key : string, value : string, expire? : number) {
        let output = btoa(unescape(encodeURIComponent(value)));
        let cookie = key + '=' + output + '; Path=/;';
    
        if (expire)
        {
            cookie += `expires=${new Date(expire)}`;
        }
    
        document.cookie = cookie;
    }

    /** void */
    public setCookieWithoutEncoding(key : string, value : string, expire? : number) {
        let cookie = key + '=' + value + '; Path=/;';

        if (expire)
        {
            cookie += `expires=${new Date(expire)}`;
        }

        document.cookie = cookie;
    }
}